import type { FC } from 'react';
import { CabinetTitlePage } from 'components/layout';
import { AddGoToTestTT } from 'features/cabinet';
import { Guard, usePermissionGuard } from 'features/login';

const AddGoToTestPage: FC = () => {
  const { accessToAddTiktokgototest } = usePermissionGuard();
  return (
    <Guard hasAccess={accessToAddTiktokgototest}>
      <CabinetTitlePage
        title={'Go To Test'}
        goBack={'/cabinet/tiktok/go-to-test'}
      />
      <AddGoToTestTT />
    </Guard>
  );
};

export default AddGoToTestPage;
